import { ApiEpBilling } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.billing.plansubscription";

export const useQueryBillingPlansubscriptionSet = (
  params?: NonNullable<
    Parameters<typeof ApiEpBilling.Plansubscription.list>[0]
  >["query"],
  options?: Omit<
    UseQueryOptions<
      Await<ReturnType<typeof ApiEpBilling.Plansubscription.list>>
    >,
    "queryKey" | "queryFn"
  >,
) =>
  useQuery<Await<ReturnType<typeof ApiEpBilling.Plansubscription.list>>>(
    [KEY, params],
    () =>
      ApiEpBilling.Plansubscription.list(
        params ? { query: params } : undefined,
      ),
    options,
  );

useQueryBillingPlansubscriptionSet.KEY = KEY;
